module.exports = __webpack_public_path__ + "static/media/circleFrame2.4cd0f72d.svg";